export const getUrlEndPath = (url: string): string => {
  if (!url) return ''

  try {
    return new URL(url).pathname.replace(/^\/+/, '')
  } catch (_) {
    return url
  }
}
